import { render, staticRenderFns } from "./lbil-linkage-blurb-popup.html?vue&type=template&id=ce5570f2&scoped=true&external"
import script from "./lbil-linkage-blurb-popup.js?vue&type=script&lang=js&external"
export * from "./lbil-linkage-blurb-popup.js?vue&type=script&lang=js&external"
import style0 from "./lbil-linkage-blurb-popup.scss?vue&type=style&index=0&id=ce5570f2&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce5570f2",
  null
  
)

export default component.exports